import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {security,hosts} from "../env/Environment";
import {Ajax} from "../Service/ajax";
import {ClipLoader} from "react-spinners";
import {formatNumber} from "../config/AppConfig";
import Swal from "sweetalert2";
import MySwal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
export default function WithdrawalRequestView() {
    const navigate = useNavigate();
    const location = useLocation();
    const company = location.state?.company;
    const session = sessionStorage.getItem("session");
    const [prefix, setPrefix] = useState("243");
    const [suffix, setSuffix] = useState("");
    const [account, setAccount] = useState("");
    const [full_name, setFull_name] = useState("");
    const [expiration_date, setExpiration_date] = useState("");
    const [control, setControl] = useState("");
    const [provider, setProvider] = useState(null);
    const[ref, setRef] = useState("");
    const[cnlUrl, setCnlUrl] = useState("");
    const [cfrmUrl, setCfrmUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const continue_url=window.location.origin+"/withdrawal-check?trs="+ref;
    const [isValidAccount, setIsValidAccount] = useState(false);
    const [isValidAmount, setIsValidAmount] = useState(false);
    const [providerType, setProviderType] = useState("Netikash Pay - Particulier");
    const [providers, setProviders] = useState([]);
    //const [providers, setProviders] = useState([]);
    const [loadingProviders, setLoadingProviders] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [providerTypes, setProviderTypes] = useState([]);
    const [category, setCategory] = useState("");
    const [providersRegex, setProvidersRegex] = useState([]);
    const [user, setUser] = useState(null);
    const [cmpAccount, setCmpAccount] = useState({
        currency:'CDF',
        balance:0
    });
    const [amount, setAmount] = useState(0);
    const [currency, setCurrency] = useState('CDF');
    const regex = /^(80|81|82|83|84|85|90|95|97|98|99)[0-9]{7}$/;


    const dataToSend={
        company_id: company.id,
        currency: cmpAccount.currency,
        ref: ref,
        app_id: security.app_id,
        label: "retrait ",
        amount: amount,
        callbackUrl: {
            continue_url: continue_url,
            confirm_callback_url: cfrmUrl,
            cancel_callback_url: cnlUrl
        },
        buyer: {
            provider_id: provider ? provider.id : null,
            prefix: prefix,
            account: account,
            suffix: suffix,
            full_name: full_name,
            expiration_date: expiration_date,
            control: control
        }
    }

    const model = {
        receiver_id: null,
        sender_id: company.id,
        solution_id: security.ntk_sol_id,
        currency: cmpAccount.currency,
        accountable: user?.id || null,
        service: null,
        ref: uuidv4(),
        label: "Retrait ver ",
        amount: amount,
        method: {
            provider_id: provider ? provider.id : null,
            prefix: prefix,
            account: account,
            suffix: suffix,
            full_name: full_name,
            expiration_date: expiration_date,
            control: control
        },
    }




    function capitalizeWords(str) {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }




    function formatBankAccountNumber(value) {
        return value.replace(/\s+/g, "") //
            .replace(/(.{4})/g, "$1 ")
            .trim();
    }

    const onSelectCategory=async (item)=>{
        try {
            setLoadingProviders(true);
            console.log('item id is: ', item.value)
            const {data} = await Ajax.getRequest("/api/v1/trs/providers", {params: {pge: 1, lmt: 100, slug: "", trg:"withdrawal", typ:item}});
            console.log("element",data)
            if (data){
                setProviders(data.contents);
            }
        }catch (error){
            console.log(error)
        }
        finally{
            setLoadingProviders(false);
        }
    }

    // const fetchCategories = async () => {
    //     try {
    //         setLoading(true);
    //         const { data } = await Ajax.getRequest("/api/v1/cmp/categories/all", {
    //             params: {
    //                 pge: 1,
    //                 lmt: 100,
    //                 slug: "",
    //             }
    //         });
    //
    //         setCategories(data.contents);
    //         console.log("Toutes les catégories:", data.contents);  // Vérification de la liste des catégories
    //     } catch (error) {
    //         console.log("Erreur lors du chargement des catégories:", error.message);
    //     } finally {
    //         setLoading(false); // Fin du chargement
    //     }
    // };


    useEffect(() => {
        if (category) {
            let providerList = providers.filter(provider => provider.provider_type === category);
            setProvidersRegex(providerList)
            setProvider(providerList[0])
            setAccount("");
            console.log(providerList);
        }
    }, [category]);


    // const reset = () =>{
    //     setNumero('');
    //     setHashTag('');
    //     setProviderInput(null);
    //     setSelectedProvider(null);
    //     setProviderId(null);
    //     setSelectedChoice(null);
    // }

    // const validateIBAN = (input) => {
    //     const formattedIban = input.replace(/\s+/g, '').toUpperCase();
    //
    //     if (formattedIban.length < 15 || formattedIban.length > 34) {
    //         return { isValid: false, message: 'Longueur invalide pour un IBAN.' };
    //     }
    //
    //     const rearrangedIban = formattedIban.slice(4) + formattedIban.slice(0, 4);
    //     const numericIban = rearrangedIban
    //         .split('')
    //         .map((char) => (char >= 'A' && char <= 'Z' ? char.charCodeAt(0) - 55 : char))
    //         .join('');
    //
    //     const isValid = BigInt(numericIban) % 97n === 1n;
    //
    //     return {
    //         isValid,
    //         message: isValid ? 'IBAN valide.' : 'Clé de contrôle incorrecte.',
    //     };
    // };




    const initData = {
        company:company.id,
        currency:cmpAccount.currency,
        withdrawalAccount:"0"+account,
        amount:amount
    }
    function validateNumber(inputValue) {
        const regex = new RegExp(provider.account_format);
        if (regex.test(inputValue)) {
            setIsValidAccount(true)
            setAccount(inputValue);
        } else {
            setIsValidAccount(false)
            setAccount(inputValue);
        }
    }

    function validateBankAccount(inputValue) {
        const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

        if (ibanRegex.test(inputValue)) {
            setIsValidAccount(true);
            setAccount(inputValue);
        } else {
            setIsValidAccount(false);
            setAccount(inputValue);
        }
    }

    function validateTag(inputValue) {
        const regex = /^\$[a-zA-Z0-9_]+$/;
        if (regex.test(inputValue)) {
            setIsValidAccount(true)
            setAccount(inputValue);
        } else {
            setIsValidAccount(false)
            setAccount(inputValue);
        }
    }


    const handleSubmit = () => {
        const fetchData = async () => {

            try {
                setLoading(true)
                const {data} = await Ajax.postRequest("/api/v1/trs/transactions/requests/withdrawals",model);
                if(!data.error){
                    let presence="withdrawal"
                    navigate("/withdrawal-confirmation",{ state: { company, presence } })
                }else{
                    Swal.fire({
                            title: 'Error!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true
                        }
                    )
                }
            } catch (error) {
                Swal.fire({
                        title: 'Error!',
                        text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true
                    }
                )
            }finally {
                setLoading(false)
            }
        };
        if(!session){
            navigate("/");
        }else{
            fetchData();
        }
    }
    const handleCurrencyChange = async (e) => {
        const {value} = e.target;
        setCurrency(value);
        try {
            const countBalance = await Ajax.getRequest('/api/v1/trs/accounts', { params: { crc: value, own: company.id } });
            setCmpAccount(countBalance.data)
        } catch (error) {
            let errorCode;
            if (error.response) {
                errorCode = error.response.status;
            } else {
                errorCode = 500;
            }
            navigate('/error-page', { state: { errorCode } });
        }
    };

    function handleGoBack() {
        window.history.back();
    }

    const handleCategoryChange = async (e) => {
        const {value} = e.target;
        setCategory(value);
        console.log(value);

    };

    const handleProviderChange = async (e) => {
        const {value} = e.target;
        let provider = providers.find(provider => provider.id === value);
        setProvider(provider);
        setAccount("");

    };

    // const handleProviderChange = async (e) => {
    //     const {value} = e.target;
    //     setIsValidAccount(false)
    //     setAccount("");
    //     setProviderType(value);
    // };

    const handleAmountChange = async (e) => {
        let { value } = e.target;

        if (value === "") {
            value = "0";
        }

        value = value.replace(/^0+/, "");

        const parsedValue = parseInt(value, 10);

        if (isNaN(parsedValue)) {
            value = "0";
        } else {
            value = String(parsedValue);
        }

        setAmount(value);

        // Vérifier si le montant est valide
        if (parsedValue > cmpAccount.balance || value==="0") {
            setIsValidAmount(false);
        } else {
            setIsValidAmount(true);
        }
    }


    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);

                // Récupérer les types de fournisseurs
                const { data: providerTypesData } = await Ajax.getRequest("/api/v1/trs/providers/provider-types");
                setProviderTypes(providerTypesData.contents);

                // Récupérer les fournisseurs
                const { data: providersData } = await Ajax.getRequest("/api/v1/trs/providers", { params: { pge: 1, typ: "all", opr: "WDL", lmt: 100, slug: "" } });
                setProviders(providersData.contents);

                // Récupérer le premier fournisseur et les informations du compte
                setProvider(providersData.contents[0]);
                const { data: companyAccountData } = await Ajax.getRequest('/api/v1/trs/accounts', { params: { crc: "CDF", own: company.id } });
                setCmpAccount(companyAccountData);

                // Récupérer les informations de l'utilisateur en session
                const { data: userData } = await Ajax.getRequest(`/api/v1/usr/users/session`);
                setUser(userData);

            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            } finally {
                setLoading(false);
            }
        };

        if (!session || !company) {
            navigate("/login");
        } else {
            fetchAllData();
        }
    }, []);

    return (
        <div className="container-md">
  <div className="authentication-wrapper cd-flex justify-content-center align-items-center">
    <div className="authentication-inner">
      <div className="card">
        <div className="card-body">
          <div className="app-brand justify-content-center">
            <div>
              <img
                src={require("../assets/img/illustrations/Netikash subscribe.png")}
                alt="Netiaksh Logo"
                className="mb-3"
                style={{ width: 100 }}
              />
            </div>
          </div>
          {/* Titre en haut */}
          <h4 className="mb-3 text-netikash">Confirmer votre retrait!</h4>
          <p className="mb-4">Veuillez fournir les informations suivantes pour finaliser votre retrait.</p>

          {/* Conteneur à deux colonnes */}
          <div className="row">
            {/* Colonne gauche */}
            <div className="col-md-6">
              <div className="input-group mb-3">
                <span className="input-group-text fw-bold">Devise</span>
                <select
                  className="form-select"
                  id="devise"
                  value={currency}
                  onChange={handleCurrencyChange}
                >
                  <option defaultValue="CDF">CDF</option>
                  <option value="USD">USD</option>
                </select>
              </div>

              <div className="input-group mb-3">
                <span className="input-group-text fw-bold">Montant</span>
                <input
                  type="number"
                  className="form-control"
                  id="amount"
                  placeholder="Entrer le montant..."
                  value={amount}
                  onChange={handleAmountChange}
                />
                <span className="input-group-text">
                  {
                    isValidAmount ? (
                      <i className="bx bx-check-double text-success"></i>
                    ) : (
                      <i className="bx bx-x bx-burst text-danger"></i>
                    )
                  }
                </span>
              </div>
                <div className="input-group mb-3">
                    <span className="input-group-text fw-bold">Retrait vers</span>
                    <select
                        className="form-select"
                        id="providerType"
                        onChange={handleCategoryChange}
                    >
                        {providerTypes.map((provider, index) => (
                            <option key={index} value={provider}>
                                {capitalizeWords(provider)}
                            </option>
                        ))}
                    </select>
                </div>

                {category && (
                    <div className="input-group mb-3">
                        <select
                            className="form-select"
                            id="providerType"
                            onChange={handleProviderChange}
                        >
                            {providersRegex.map((provider, index) => (
                                <option key={provider.id} value={provider.id}>
                                    {capitalizeWords(provider.name)}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                {provider && (provider.provider_type === "MOBILE MONEY" || provider.provider_type === "netikash") && (
                    <div className="input-group input-group-merge mb-3">
                        <span className="input-group-text fw-bold">{prefix}</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={provider.account_label}
                            value={account}
                            id="account"
                            onChange={(e) => validateNumber(e.target.value)}
                        />
                        <span className="input-group-text">
                    {
                        isValidAccount ? (
                            <i className="bx bx-check-double text-success"></i>
                        ) : (
                            <i className="bx bx-x bx-burst text-danger"></i>
                        )
                    }
                  </span>
                    </div>
                )}
                {provider && provider.provider_type === "banque" && (
                    <div className="input-group input-group-merge mb-3">
                        <input
                            type="text"
                            className={"form-control"}
                            placeholder="Entrer votre numéro de compte bancaire"
                            value={account}
                            id="account"
                            maxLength={provider.account_length}
                            onChange={(e) => validateNumber(e.target.value)}
                        />
                        <span className="input-group-text">
                          {
                              isValidAccount ?
                                  <i className='bx bx-check-double text-success'></i> :
                                  <i className='bx bx-x bx-burst text-danger'></i>
                          }
                        </span>
                    </div>
                )}
            </div>

            {/* Colonne droite */}
            <div className="col-md-6">
                <div className="mb-3 d-flex justify-content-between">
                    <h5 className="card-text fw-bold">Mon solde</h5>
                    <h5 className={cmpAccount.balance > 0 ? "card-text" : "text-danger card-text"}>{cmpAccount.balance}{cmpAccount.currency}</h5>
                </div>
                <div className="card p-3 shadow-sm h-75 mb-3">
                    {/* Vérification si aucune information n'est présente */}
                    {amount===0 && !category && !account ? (
                        <div className="text-center text-danger">
                            <p className="fw-bold">Remplissez les informations</p>
                        </div>
                    ) : (
                        <>
                            {amount !== 0 && (
                                <div className="mb-2 d-flex justify-content-between">
                                    <p className="card-text fw-bold">Montant:</p>
                                    <p className={cmpAccount.balance > 0 ? "card-text" : "text-danger card-text"}>
                                        {amount}
                                        {cmpAccount.currency}
                                    </p>
                                </div>
                            )}
                            {category && (
                                <div className="mb-2 d-flex justify-content-between">
                                    <p className="card-text fw-bold">Retrait vers:</p>
                                    <p className="card-text">{capitalizeWords(category)}</p>
                                </div>
                            )}
                            {provider && provider.provider_type === "MOBILE MONEY" && (
                                <div className="mb-2 d-flex justify-content-between">
                                    <p className="card-text fw-bold">Provider:</p>
                                    <p className="card-text">{capitalizeWords(provider.name)}</p>
                                </div>
                            )}
                            {provider && provider.provider_type === "banque" && (
                                <div className="mb-2 d-flex justify-content-between">
                                    <p className="card-text fw-bold">Nom de la banque:</p>
                                    <p className="card-text">{capitalizeWords(provider.name)}</p>
                                </div>
                            )}
                            {account && (
                                <div className="mb-2 d-flex justify-content-between">
                                    <p className="card-text fw-bold">Numero:</p>
                                    <p className="card-text">
                                        {provider && provider.provider_type === "banque"
                                            ? formatBankAccountNumber(account)
                                            : prefix+" "+account}
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
          </div>

          {/* Boutons en bas */}
          <div className="row mt-3">
            <div className="col-md-6">
              <button
                className="btn btn-danger w-100"
                onClick={handleGoBack}
              >
                Annuler
              </button>
            </div>
            <div className="col-md-6">
              <button
                className={!isValidAccount ? "btn btn-netikash w-100 disabled" : "btn btn-netikash w-100"}
                onClick={handleSubmit}
              >
                {loading && <ClipLoader color="#36d7b7" loading size={15} />}
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    );
}